import MenuItem from "@mui/material/MenuItem";
import Menu from "@/components/menu";
import { useRouter } from "next/navigation";
import GetIcon from "@/components/font-awesome-icon";

const selectedStyles = (isSelected = false) => {
  return {
    // background: "#fff !important",
    color: isSelected ? "var(--palette-secondary_button_text)" : "inherit",
    background: "none !important",
    "&:hover": {
      color: "var(--palette-secondary_button_text)",
      background: "var(--palette-secondary_button_hover) !important",
    },
    ".MuiFormControlLabel-label": {
      fontWeight: isSelected ? "600" : "inherit",
    },
  };
};

const NavMenu = ({
  name,
  anchorEl,
  isMenuOpen,
  handleMenuClose,
  menuOptions = [],
  pathname = "",
  roles = {},
}) => {
  const router = useRouter();
  const menuId = `${name}-menu`;

  const handleClick = (e, item) => {
    handleMenuClose(e);
    if (!pathname?.endsWith(item?.path)) {
      setTimeout(() => {
        router.push(item?.path);
      }, 300);
    }
  };

  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      id={menuId}
      keepMounted={false}
      open={isMenuOpen}
      onClose={handleMenuClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      {menuOptions &&
        menuOptions.map(
          (opt, index) =>
            (roles[name][opt.name]?.view || roles[opt.name]?.view) && (
              <MenuItem
                key={index}
                onClick={(e) => handleClick(e, opt)}
                sx={{
                  minWidth: "150px",
                  ...selectedStyles(pathname?.endsWith(opt?.path)),
                }}
                selected={pathname?.endsWith(opt?.path)}
              >
                <GetIcon
                  title={opt?.title}
                  iconStyles={{
                    marginRight: "10px",
                    fontSize: "1.2rem",
                  }}
                  icon={opt?.icon}
                />
              </MenuItem>
            )
        )}
    </Menu>
  );
  return renderMenu;
};

export default NavMenu;
